module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/10.b3872035.png";